export default __webpack_public_path__ + "static/media/admin_02.4b5dd664.png";